import { create } from "zustand";

export const useSidebarStore = create((set) => ({
  isSidebarOpen: true, // Default open on desktop
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  setSidebarOpen: (isOpen) => set({ isSidebarOpen: isOpen }),
}));
